import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { CommonService } from '../../../../shared/services/common.service'
import { environment } from '../../../../../environments/environment'

@Component({
  standalone: false,

  selector: 'vs-product-lines',
  templateUrl: './product-lines.component.html',
  styleUrls: ['./product-lines.component.scss'],
})
export class ProductLinesComponent implements OnInit {
  productLines: any // = PRODUCTS_LISTING_PLP_MENU;
  plpMenusCustom: any

  valvesLink: any = environment.bhValves

  constructor(private router: Router, private commonService: CommonService) {}

  ngOnInit(): void {
    const apiParam = ['vsCategories', 'undefined'] //'ECOM_LVL0_00000002'];
    const apiUrl = this.commonService.constructUrl(apiParam)
    this.commonService.getData_WithoutRetry(apiUrl).subscribe((data) => {
      this.plpMenusCustom = {}
      if (
        data['childCategories'] !== undefined &&
        data['childCategories'] !== null
      ) {
        for (let i = 0; i < data['childCategories'].length; i++) {
          if (data['childCategories'][i].name !== undefined) {
            this.plpMenusCustom[data['childCategories'][i].name.toUpperCase()] =
              data['childCategories'][i].code
          }
        }
      }

      this.productLines = this.plpMenusCustom
    })
  }

  redirectToProductCategory(cat) {
    this.router.navigate(['/categories/' + cat])
  }
}
